// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__328S_","title":"AfterFrontImage_title__26SF3"};